import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, Search, Filter } from 'lucide-react';
import { Link } from 'react-router-dom';
export const Insights = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const categories = ['All', 'Tax Advisory', 'Strategic Advisory', 'Capital', 'Global Markets', 'Policy'];
  const posts = [{
    title: 'Strategic Tax Planning for Cross-Border Business',
    category: 'Tax Advisory',
    date: 'July 12, 2024',
    author: 'Managing Partner',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/beb12f25-1672-451d-b509-1a1ff4f650cc.jpg',
    featured: true,
    excerpt: 'Navigating the complexities of international tax laws requires a proactive approach and deep technical mastery. Discover how to optimize your global tax position.'
  }, {
    title: 'Investment Strategies in Emerging Markets',
    category: 'Capital',
    date: 'July 10, 2024',
    author: 'Managing Partner',
    img: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?auto=format&fit=crop&q=80',
    featured: false
  }, {
    title: 'Navigating International Expansion Complexity',
    category: 'Advisory',
    date: 'July 08, 2024',
    author: 'Managing Partner',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/9edda6d8-d096-4dec-8406-49d89899a16e.jpg',
    featured: false
  }, {
    title: 'The Future of Sustainable Agriculture in Africa',
    category: 'Global Markets',
    date: 'July 05, 2024',
    author: 'Managing Partner',
    img: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&q=80',
    featured: false
  }, {
    title: 'Governance and Policy: Shaping the Future',
    category: 'Policy',
    date: 'July 01, 2024',
    author: 'Managing Partner',
    img: 'https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&q=80',
    featured: false
  }, {
    title: 'Wealth Preservation for High-Net-Worth Individuals',
    category: 'Tax Advisory',
    date: 'June 28, 2024',
    author: 'Managing Partner',
    img: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?auto=format&fit=crop&q=80',
    featured: false
  }];
  const filteredPosts = posts.filter(post => {
    const matchesCategory = activeCategory === 'All' || post.category === activeCategory;
    const matchesSearch = post.title.toLowerCase().includes(searchQuery.toLowerCase()) || post.excerpt && post.excerpt.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });
  return <main className="pt-24 bg-brand-warm-white min-h-screen" data-id="element-431" data-mp="v644hlgsl26t">
      {/* Header */}
      <section className="bg-brand-navy py-24 text-white relative overflow-hidden" data-id="element-432" data-mp="104yogqqhwwsi">
        <div className="absolute inset-0 opacity-10" data-id="element-433" data-mp="skwcm8q2cur4">
          <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/patterns/generated-images/117d0dd0-f932-4c9a-8c93-2d7bc64949ec.jpg')] bg-cover bg-center" data-id="element-434" data-mp="smhc8cr8j3vu" />
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-435" data-mp="iuusfs0tzwhh">
          <span className="text-brand-gold font-bold tracking-widest uppercase text-sm mb-6 block" data-id="element-436" data-mp="16i2wk6miwzhx">
            Thought Leadership
          </span>
          <h1 className="text-5xl md:text-7xl font-display mb-8" data-id="element-437" data-mp="wmrfvirk1i7j">
            Featured <br data-id="element-438" data-mp="3mba8zqfdcz1g" />
            <span className="italic" data-id="element-439" data-mp="3mbthkgj4qb2t">Insights</span>.
          </h1>
          <p className="text-xl text-white/70 max-w-2xl leading-relaxed" data-id="element-440" data-mp="3m8xigovjpgcs">
            Strategic analysis and expert perspectives on finance, advisory, and
            global commerce.
          </p>
        </motion.div>
      </section>

      {/* Filter Bar */}
      <section className="sticky top-20 z-30 bg-white/80 backdrop-blur-md border-b border-brand-navy/5 py-4" data-id="element-441" data-mp="1esidddq007y0">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-442" data-mp="104duo9qy3wf8">
          <div className="flex gap-6 overflow-x-auto no-scrollbar w-full md:w-auto pb-2 md:pb-0" data-id="element-443" data-mp="15271n502ougk">
            {categories.map((cat, i) => <button key={i} onClick={() => setActiveCategory(cat)} className={`text-xs font-bold uppercase tracking-widest whitespace-nowrap transition-colors ${activeCategory === cat ? 'text-brand-gold' : 'text-brand-charcoal/40 hover:text-brand-navy'}`} data-id="element-444" data-mp="1xr4hl1gtaf65" data-mpi={i}>
                {cat}
              </button>)}
          </div>
          <div className="relative w-full md:w-64" data-id="element-445" data-mp="cczyfspobgoz">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-brand-charcoal/30" size={16} data-id="element-446" data-mp="cejhts6mm7uz" />
            <input type="text" placeholder="Search Insights..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full bg-brand-warm-white border-none py-3 pl-12 pr-4 rounded-full text-sm outline-none focus:ring-1 focus:ring-brand-gold" data-id="element-447" data-mp="2lmfv0azcaqy8" />
          </div>
        </div>
      </section>

      {/* Insights Grid */}
      <section className="py-24" data-id="element-448" data-mp="22whs09aefo1g">
        <div className="max-w-7xl mx-auto px-6" data-id="element-449" data-mp="22tc0kneasa2k">
          <AnimatePresence mode="popLayout" data-id="element-450" data-mp="2gn38xsgalnwp">
            {filteredPosts.length > 0 ? <motion.div layout className="grid lg:grid-cols-3 gap-12" data-id="element-451" data-mp="2bvl7z4e9rnbq">
                {filteredPosts.map((post, i) => <motion.div key={post.title} layout initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0,
              scale: 0.9
            }} transition={{
              duration: 0.4
            }} className={`${post.featured ? 'lg:col-span-3 mb-12' : ''} group`} data-id="element-452" data-mp="1o57q26pef4uv" data-mpi={i}>
                    <Link to={`/insights/${post.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)+/g, '')}`} state={{
                post
              }} className={`${post.featured ? 'grid lg:grid-cols-2 gap-12 items-center' : 'flex flex-col h-full'} block`} data-id="element-453" data-mp="359nxit5mgzgy">
                      <div className={`relative overflow-hidden rounded-3xl ${post.featured ? 'aspect-[16/9]' : 'aspect-[4/3] mb-8'}`} data-id="element-454" data-mp="ugbepknxs3m6">
                        <img src={post.img} alt={post.title} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-455" data-mp="2a255g6v78t4z" />
                        <div className="absolute top-6 left-6 bg-white/90 backdrop-blur-md px-4 py-1 text-[10px] font-bold tracking-widest uppercase text-brand-navy" data-id="element-456" data-mp="1vbo931xf8tey">
                          {post.category}
                        </div>
                      </div>
                      <div className={post.featured ? 'py-8' : 'flex flex-col flex-grow'} data-id="element-457" data-mp="1mdc7k4v0ob7q">
                        <div className="text-brand-charcoal/40 text-xs uppercase tracking-widest mb-4 flex items-center gap-4" data-id="element-458" data-mp="3gohhts0lzlw1">
                          <span data-id="element-459" data-mp="2kkttip73x055">{post.date}</span>
                          <span className="w-1 h-1 rounded-full bg-brand-gold" data-id="element-460" data-mp="2km4xap0jy7w9" />
                          <span data-id="element-461" data-mp="2pk6jhit9ynby">{post.author}</span>
                        </div>
                        <h3 className={`${post.featured ? 'text-4xl md:text-5xl' : 'text-2xl'} font-display text-brand-navy group-hover:text-brand-gold transition-colors leading-tight mb-6`} data-id="element-462" data-mp="2avk2lco01nim">
                          {post.title}
                        </h3>
                        {post.featured && <p className="text-brand-charcoal/60 text-lg leading-relaxed mb-8 max-w-xl" data-id="element-463" data-mp="26uqbkaf9fsli">
                            {post.excerpt}
                          </p>}
                        <div className="mt-auto inline-flex items-center gap-3 text-brand-navy font-bold tracking-widest uppercase text-xs border-b-2 border-brand-gold pb-2 group-hover:gap-5 transition-all self-start" data-id="element-464" data-mp="1wxby8jomvjxf">
                          Read Article{' '}
                          <ArrowRight size={16} className="text-brand-gold" data-id="element-465" data-mp="1fmykeko2virs" />
                        </div>
                      </div>
                    </Link>
                  </motion.div>)}
              </motion.div> : <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} className="text-center py-20" data-id="element-466" data-mp="1pdjepvwpy14w">
                <h3 className="text-2xl font-display text-brand-navy mb-4" data-id="element-467" data-mp="28acca4cx5o51">
                  No Insights Found
                </h3>
                <p className="text-brand-charcoal/60" data-id="element-468" data-mp="23cj7nfr9l26v">
                  We couldn't find any articles matching your current filters.
                </p>
                <button onClick={() => {
              setActiveCategory('All');
              setSearchQuery('');
            }} className="mt-8 text-brand-gold font-bold tracking-widest uppercase text-xs border-b border-brand-gold/30 pb-1 hover:border-brand-gold transition-all" data-id="element-469" data-mp="8xgl9qxii086">
                  Clear Filters
                </button>
              </motion.div>}
          </AnimatePresence>

          {/* Pagination */}
          <div className="mt-24 flex justify-center gap-4" data-id="element-470" data-mp="1qaoond31kmiw">
            <button className="w-12 h-12 rounded-full border border-brand-navy/10 flex items-center justify-center text-brand-navy font-bold hover:bg-brand-navy hover:text-white transition-all" data-id="element-471" data-mp="1qa6inoqkutxs">
              1
            </button>
            <button className="w-12 h-12 rounded-full border border-brand-navy/10 flex items-center justify-center text-brand-charcoal/40 font-bold hover:border-brand-navy hover:text-brand-navy transition-all" data-id="element-472" data-mp="1cj9wafn8v8z6">
              2
            </button>
            <button className="w-12 h-12 rounded-full border border-brand-navy/10 flex items-center justify-center text-brand-charcoal/40 font-bold hover:border-brand-navy hover:text-brand-navy transition-all" data-id="element-473" data-mp="249o35rwubl1c">
              3
            </button>
          </div>
        </div>
      </section>
    </main>;
};